import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getTopServices,
  getTopServiceGroups,
  getTopEmployees,
  // getTopServicesDoctor,
} from "../../../../actions/statisticActions";
import { Flex, Heading, Spinner, Text, Image } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { primary, textSecondary } from "../../../../utils/colors";
import noServices from "../../../../assets/images/empty-box.png";
import BoxListItemNew from "./BoxListItemNew";
import useThemeColors from "../../../../hooks/useThemeColors";
import { formatNumberWithCommas } from "../../../../utils/formatUtils";
import { useParams } from "react-router-dom";
// import useCurrencySymbol from "../../../../hooks/useCurrencySymbol";

const DashboardTopServices = ({ currency }) => {
  // GENERAL
  const { slug } = useParams();
  const { t } = useTranslation();

  // COLORS
  const { whiteMode, newBorderMode, textPrimaryMode } = useThemeColors();

  //STATE
  // const currencySymbol = useCurrencySymbol(currency);

  // REDUX
  const dispatch = useDispatch();

  const statisticTopService = useSelector((state) => state.statisticTopService);
  const { loading, error, statisticTopServices } = statisticTopService;

  // USEEFFECT
  useEffect(() => {
    dispatch(getTopServices(slug));
    dispatch(getTopServiceGroups(slug));
    dispatch(getTopEmployees(slug));
    // dispatch(getTopServicesDoctor());
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch.slug]);

  // LOG

  // Helper function to render content based on data availability
  const renderContent = (data, loading, currency) => {
    if (loading) return <Spinner size="md" color={primary} />;

    if (data && data.length > 0) {
      return (
        <>
          {data.map((item, index) => (
            <BoxListItemNew
              key={index}
              label={
                item.serviceName || item.serviceGroupName || item.employeeName
              }
              data={formatNumberWithCommas(item.totalRevenue.toFixed(2))}
              bg={whiteMode}
              isPrice={true}
              color={textSecondary}
              currency={currency}
            />
          ))}
        </>
      );
    }

    // Render this when there's no data and not loading
    return (
      <>
        <Flex direction="column" justify="center" align="center" w="100%" p={0}>
          <Image h="initial" w="2.5rem" m="1rem 0 0" src={noServices} />
          <Text mt={2} color={textSecondary} fontSize="sm">
            {t("common.noData")}
          </Text>
        </Flex>
      </>
    );
  };

  // ERROR
  if (error) return <p>Error: {error}</p>;

  // LOGS

  return (
    <Flex
      w="100%"
      direction="column"
      border={`0px solid ${newBorderMode}`}
      borderRadius="1rem"
    >
      <Flex
        w="100%"
        align="center"
        justify="space-between"
        minH="2rem"
        p="0.5rem 0"
      >
        <Flex align="center">
          <Heading
            fontSize="1rem"
            fontWeight="600"
            color={textPrimaryMode}
            whiteSpace="nowrap"
          >
            {t("dashboard.top3Services")}
          </Heading>
        </Flex>
      </Flex>

      <Flex direction="column">
        <Flex direction="column" w="100%" p="0 0rem" minH="110px">
          {renderContent(statisticTopServices, loading, currency)}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default DashboardTopServices;
